import React, { Component } from 'react';
import { Modal, Button } from 'antd';

interface DeleteWarningModalProps {
    isOpen: boolean;
    closeCallback: () => void;
    delete: (record: any) => Promise<any>;
    update: () => Promise<void>;
    itemTypeToDelete: string;
    itemNameToDelete: string;
    itemRecordToDelete?: number;
}

class DeleteWarningModal extends Component<DeleteWarningModalProps> {
    close = () => {
        this.props.closeCallback();
    }

    deleteAppropriateItem = async () => {
        try {
            await this.props.delete(this.props.itemRecordToDelete);
        }
        catch(error) {
            alert('Error while deleting ' + this.props.itemNameToDelete);
        }
        finally {
            await this.props.update();
            this.close();
        }
    }

    render() {
        return(
            <Modal
                title={"Delete " + this.props.itemTypeToDelete}
                open={this.props.isOpen}
                onCancel={() => this.close()}
                footer={[
                    <Button style={{background: "#E60013", borderColor: "#E60013", color: "#F5F5F5"}} key="submit" type="primary" onClick={ async () => {
                        await this.deleteAppropriateItem();
                    }
                    }>
                        Delete
                    </Button>,
                    <Button key="back" onClick={() => this.close()}>
                        Cancel
                    </Button>
                ]}
            >
                Are you sure you want to delete {this.props.itemTypeToDelete.toLowerCase()}: <b>{this.props.itemNameToDelete}</b>?
            </Modal>
        );
    }
}

export default DeleteWarningModal;